// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_Www","cls2":"common-cls2_KwG common-cls1_Www","bigMargin":"common-bigMargin_bEH","bold":"common-bold_Yb4","mono":"common-mono_EPw"};